import { render } from "./ClientUsersModal.vue?vue&type=template&id=23d05e6d&scoped=true&ts=true"
import script from "./ClientUsersModal.vue?vue&type=script&lang=ts"
export * from "./ClientUsersModal.vue?vue&type=script&lang=ts"

import "./ClientUsersModal.vue?vue&type=style&index=0&id=23d05e6d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d05e6d"]])

export default __exports__